/* ==========================================================================
   Moonou Buy Box - JavaScript
   Delivery date calculator + Countdown auto-renew
   ========================================================================== */

(function () {
  'use strict';

  /**
   * Calculate and display delivery dates in DD.MM format (German).
   * Reads data-delivery-min and data-delivery-max from [data-moonou-delivery].
   */
  function initDeliveryDates() {
    var elements = document.querySelectorAll('[data-moonou-delivery]');
    elements.forEach(function (el) {
      var min = parseInt(el.getAttribute('data-delivery-min'), 10) || 3;
      var max = parseInt(el.getAttribute('data-delivery-max'), 10) || 5;
      var now = new Date();

      var dateMin = new Date(now);
      dateMin.setDate(dateMin.getDate() + min);
      var dateMax = new Date(now);
      dateMax.setDate(dateMax.getDate() + max);

      var formatted = pad(dateMin.getDate()) + '.' + pad(dateMin.getMonth() + 1)
        + ' - '
        + pad(dateMax.getDate()) + '.' + pad(dateMax.getMonth() + 1);

      var target = el.querySelector('[data-delivery-dates]');
      if (target) {
        target.textContent = formatted;
      }
    });
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /**
   * Auto-renew countdown: calculates next expiry time and sets data-expires
   * before the theme's <countdown-timer> reads it.
   */
  function initCountdownAutoRenew() {
    var elements = document.querySelectorAll('[data-moonou-countdown][data-auto-renew]');
    elements.forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-renew-hour'), 10);
      var minute = parseInt(el.getAttribute('data-renew-minute'), 10);
      if (isNaN(hour)) hour = 23;
      if (isNaN(minute)) minute = 59;

      var now = new Date();
      var expiry = new Date(now);
      expiry.setHours(hour, minute, 0, 0);

      // If we're past today's expiry time, set to tomorrow
      if (now >= expiry) {
        expiry.setDate(expiry.getDate() + 1);
      }

      // Set the expires attribute as ISO string for countdown-timer
      el.setAttribute('data-expires', expiry.toISOString());

      // Also update the inner countdown-timer if it exists
      var timer = el.querySelector('countdown-timer');
      if (timer) {
        timer.setAttribute('data-expires', expiry.toISOString());
      }
    });
  }

  /* ---- Image Overlay ---- */

  var overlayObserver = null;
  var injectedOverlays = [];

  function initImageOverlays() {
    destroyImageOverlays();

    var section = document.querySelector('.moonou-product');
    if (!section) return;

    var templates = section.querySelectorAll('template[data-overlay-target]');
    if (!templates.length) return;

    var gallery = section.querySelector('.product__media-list');
    if (!gallery) return;

    var mediaElements = gallery.querySelectorAll('.product__media:not([hidden])');

    templates.forEach(function (tpl) {
      var targetIndex = parseInt(tpl.getAttribute('data-overlay-target'), 10);
      if (isNaN(targetIndex) || targetIndex < 1) return;

      var mediaEl = mediaElements[targetIndex - 1];
      if (!mediaEl) return;

      var clone = tpl.content.cloneNode(true);
      var overlayEl = clone.querySelector('.moonou-overlay');
      if (!overlayEl) return;

      mediaEl.appendChild(clone);

      var inserted = mediaEl.querySelector('.moonou-overlay');
      if (inserted) {
        injectedOverlays.push({ element: inserted, parent: mediaEl });
      }
    });

    if (injectedOverlays.length > 0 && 'IntersectionObserver' in window) {
      overlayObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var overlay = entry.target.querySelector('.moonou-overlay');
          if (overlay) {
            if (entry.isIntersecting) {
              requestAnimationFrame(function () {
                overlay.classList.add('is-visible');
              });
            } else {
              overlay.classList.remove('is-visible');
            }
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -50px 0px' });

      injectedOverlays.forEach(function (item) {
        overlayObserver.observe(item.parent);
      });
    } else {
      injectedOverlays.forEach(function (item) {
        item.element.classList.add('is-visible');
      });
    }
  }

  function destroyImageOverlays() {
    if (overlayObserver) {
      overlayObserver.disconnect();
      overlayObserver = null;
    }
    injectedOverlays.forEach(function (item) {
      if (item.element && item.element.parentNode) {
        item.element.parentNode.removeChild(item.element);
      }
    });
    injectedOverlays = [];
  }

  /**
   * Initialize all Moonou buy box features.
   */
  function init() {
    initDeliveryDates();
    initCountdownAutoRenew();
    initImageOverlays();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.moonou-product')) {
      init();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector('.moonou-product')) {
      destroyImageOverlays();
    }
  });
})();
